/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OkResponse,
  RuntimeActionRequest,
  RuntimeStatusRequest,
  RuntimeTargetRecordResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiRuntimeTargetsUrl = () => {




  return `/api/runtime-targets`
}

export const getApiRuntimeTargets = async ( options?: RequestInit): Promise<RuntimeTargetRecordResponse[]> => {

  return orvalControlFetch<RuntimeTargetRecordResponse[]>(getGetApiRuntimeTargetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiRuntimeTargetsQueryKey = () => {
    return [
    `/api/runtime-targets`
    ] as const;
    }


export const getGetApiRuntimeTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRuntimeTargetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRuntimeTargets>>> = ({ signal }) => getApiRuntimeTargets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiRuntimeTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRuntimeTargets>>>
export type GetApiRuntimeTargetsQueryError = unknown


export function useGetApiRuntimeTargets<TData = Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeTargets>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeTargets<TData = Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeTargets>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeTargets<TData = Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiRuntimeTargets<TData = Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTargets>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiRuntimeTargetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiRuntimeTargetUrl = () => {




  return `/api/runtime-target`
}

export const getApiRuntimeTarget = async ( options?: RequestInit): Promise<RuntimeTargetRecordResponse> => {

  return orvalControlFetch<RuntimeTargetRecordResponse>(getGetApiRuntimeTargetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiRuntimeTargetQueryKey = () => {
    return [
    `/api/runtime-target`
    ] as const;
    }


export const getGetApiRuntimeTargetQueryOptions = <TData = Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRuntimeTargetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRuntimeTarget>>> = ({ signal }) => getApiRuntimeTarget({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiRuntimeTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRuntimeTarget>>>
export type GetApiRuntimeTargetQueryError = unknown


export function useGetApiRuntimeTarget<TData = Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeTarget>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeTarget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeTarget<TData = Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeTarget>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeTarget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeTarget<TData = Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiRuntimeTarget<TData = Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeTarget>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiRuntimeTargetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiRuntimeTargetUrl = () => {




  return `/api/runtime-target`
}

export const deleteApiRuntimeTarget = async ( options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiRuntimeTargetUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiRuntimeTargetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiRuntimeTarget>>, TError,void, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiRuntimeTarget>>, TError,void, TContext> => {

const mutationKey = ['deleteApiRuntimeTarget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiRuntimeTarget>>, void> = () => {


          return  deleteApiRuntimeTarget(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiRuntimeTargetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiRuntimeTarget>>>

    export type DeleteApiRuntimeTargetMutationError = unknown

    export const useDeleteApiRuntimeTarget = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiRuntimeTarget>>, TError,void, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiRuntimeTarget>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteApiRuntimeTargetMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeTargetProvisionUrl = () => {




  return `/api/runtime-target/provision`
}

export const postApiRuntimeTargetProvision = async (runtimeActionRequest: RuntimeActionRequest, options?: RequestInit): Promise<RuntimeTargetRecordResponse> => {

  return orvalControlFetch<RuntimeTargetRecordResponse>(getPostApiRuntimeTargetProvisionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeActionRequest,)
  }
);}




export const getPostApiRuntimeTargetProvisionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetProvision>>, TError,{data: RuntimeActionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetProvision>>, TError,{data: RuntimeActionRequest}, TContext> => {

const mutationKey = ['postApiRuntimeTargetProvision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeTargetProvision>>, {data: RuntimeActionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeTargetProvision(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeTargetProvisionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeTargetProvision>>>
    export type PostApiRuntimeTargetProvisionMutationBody = RuntimeActionRequest
    export type PostApiRuntimeTargetProvisionMutationError = unknown

    export const usePostApiRuntimeTargetProvision = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetProvision>>, TError,{data: RuntimeActionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeTargetProvision>>,
        TError,
        {data: RuntimeActionRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeTargetProvisionMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeTargetReconcileUrl = () => {




  return `/api/runtime-target/reconcile`
}

export const postApiRuntimeTargetReconcile = async (runtimeActionRequest: RuntimeActionRequest, options?: RequestInit): Promise<RuntimeTargetRecordResponse> => {

  return orvalControlFetch<RuntimeTargetRecordResponse>(getPostApiRuntimeTargetReconcileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeActionRequest,)
  }
);}




export const getPostApiRuntimeTargetReconcileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetReconcile>>, TError,{data: RuntimeActionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetReconcile>>, TError,{data: RuntimeActionRequest}, TContext> => {

const mutationKey = ['postApiRuntimeTargetReconcile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeTargetReconcile>>, {data: RuntimeActionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeTargetReconcile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeTargetReconcileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeTargetReconcile>>>
    export type PostApiRuntimeTargetReconcileMutationBody = RuntimeActionRequest
    export type PostApiRuntimeTargetReconcileMutationError = unknown

    export const usePostApiRuntimeTargetReconcile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetReconcile>>, TError,{data: RuntimeActionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeTargetReconcile>>,
        TError,
        {data: RuntimeActionRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeTargetReconcileMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeTargetDeployUrl = () => {




  return `/api/runtime-target/deploy`
}

export const postApiRuntimeTargetDeploy = async (runtimeActionRequest: RuntimeActionRequest, options?: RequestInit): Promise<RuntimeTargetRecordResponse> => {

  return orvalControlFetch<RuntimeTargetRecordResponse>(getPostApiRuntimeTargetDeployUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeActionRequest,)
  }
);}




export const getPostApiRuntimeTargetDeployMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetDeploy>>, TError,{data: RuntimeActionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetDeploy>>, TError,{data: RuntimeActionRequest}, TContext> => {

const mutationKey = ['postApiRuntimeTargetDeploy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeTargetDeploy>>, {data: RuntimeActionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeTargetDeploy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeTargetDeployMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeTargetDeploy>>>
    export type PostApiRuntimeTargetDeployMutationBody = RuntimeActionRequest
    export type PostApiRuntimeTargetDeployMutationError = unknown

    export const usePostApiRuntimeTargetDeploy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetDeploy>>, TError,{data: RuntimeActionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeTargetDeploy>>,
        TError,
        {data: RuntimeActionRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeTargetDeployMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeTargetStatusUrl = () => {




  return `/api/runtime-target/status`
}

export const postApiRuntimeTargetStatus = async (runtimeStatusRequest: RuntimeStatusRequest, options?: RequestInit): Promise<RuntimeTargetRecordResponse> => {

  return orvalControlFetch<RuntimeTargetRecordResponse>(getPostApiRuntimeTargetStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeStatusRequest,)
  }
);}




export const getPostApiRuntimeTargetStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetStatus>>, TError,{data: RuntimeStatusRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetStatus>>, TError,{data: RuntimeStatusRequest}, TContext> => {

const mutationKey = ['postApiRuntimeTargetStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeTargetStatus>>, {data: RuntimeStatusRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeTargetStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeTargetStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeTargetStatus>>>
    export type PostApiRuntimeTargetStatusMutationBody = RuntimeStatusRequest
    export type PostApiRuntimeTargetStatusMutationError = unknown

    export const usePostApiRuntimeTargetStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeTargetStatus>>, TError,{data: RuntimeStatusRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeTargetStatus>>,
        TError,
        {data: RuntimeStatusRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeTargetStatusMutationOptions(options), queryClient);
    }
